/**
 *
 * LegalDocumentForm
 *
 */

import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';
import { Form } from './Form';

interface Props {
  code: {
    code: string;
    name: string;
  };
  document?: any;
  onUpdateItem: (values: any) => void;
}
export function DocumentForm(props: Props) {
  const { code, document, onUpdateItem } = props;
  return (
    <Paper variant={'outlined'} sx={{ p: 4 }}>
      <Stack spacing={2}>
        <Typography variant={'h5'}>{code.name}</Typography>

        <Form
          name={code.name}
          code={code.code}
          data={document}
          updateItem={onUpdateItem}
        />
      </Stack>
    </Paper>
  );
}
